import React from 'react'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface StoryCardProps {
  id: string
  title: string
  cover: string
  author: string
  onClick?: () => void
  className?: string
}

const StoryCard: React.FC<StoryCardProps> = ({
  id,
  title,
  cover,
  author,
  onClick,
  className
}) => {
  return (
    <Card 
      className={cn(
        "overflow-hidden cursor-pointer",
        className
      )}
      onClick={onClick}
    >
      {/* 封面图 */}
      <div className="aspect-[4/3] relative">
        <img 
          src={cover || '/placeholder.jpg'} 
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* 信息 */}
      <div className="p-4">
        <h3 className="font-medium text-lg mb-2 line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-gray-500">
          作者：{author}
        </p>
      </div>
    </Card>
  )
}

export default StoryCard 